import React, { useState, useEffect, useRef } from 'react';
import { Send, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { investorsAPI } from '../services/api';
import { toast } from 'sonner';

const InvestorInquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const emailRef = useRef(null);

  useEffect(() => {
    try {
      if (emailRef.current) {
        emailRef.current.focus();
        emailRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } catch (e) {}
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await investorsAPI.create(formData);
      toast.success('Votre demande a été envoyée avec succès!');
      setFormData({ name: '', email: '', company: '', message: '' });
    } catch (error) {
      toast.error('Erreur lors de l\'envoi de la demande');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="glass rounded-2xl p-4 md:p-6 shadow-xl border border-slate-700/50 animate-slideIn">
      <h2 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4 flex items-center gap-2">
        <Mail className="w-5 h-5 text-blue-400" />
        Contact Investisseurs
      </h2>

      <form onSubmit={handleSubmit} className="space-y-3 md:space-y-4">
        <div>
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Votre nom"
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="investor-name-input"
          />
        </div>

        <div>
          <Input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            autoFocus
            ref={emailRef}
            data-testid="investor-email-input"
          />
        </div>

        <div>
          <Input
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder="Entreprise (optionnel)"
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="investor-company-input"
          />
        </div>

        <div>
          <Textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Votre message"
            rows={4}
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="investor-message-input"
          />
        </div>

        <Button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 hover:bg-blue-700 text-sm md:text-base px-3 py-2 md:px-4 md:py-2"
          data-testid="investor-submit-btn"
        >
          <Send className="w-4 h-4 mr-2" />
          {isSubmitting ? 'Envoi...' : 'Envoyer'}
        </Button>
      </form>
    </div>
  );
};

export default InvestorInquiry;
